var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import CloseIcon from '@mui/icons-material/Close';
import MuiAlert from '@mui/lab/Alert';
import Snackbar from '@mui/material/Snackbar';
import { memo, useCallback, useEffect, useRef, useState } from 'react';
import { AUTO_HIDE_DURATION, RESUME_HIDE_DURATION } from '../constants';
import useStyles from '../styles';
var SnackBar = function (_a) {
    var snack = _a.snack;
    var styles = useStyles({ type: snack.type });
    var timerID = useRef(0);
    var initialDuration = useRef(AUTO_HIDE_DURATION);
    var _b = useState(false), showSnack = _b[0], setShowSnack = _b[1];
    var _c = useState(AUTO_HIDE_DURATION), autoHideTimer = _c[0], setAutoHideTimer = _c[1];
    var handleClose = useCallback(function (_, reason) {
        if (reason === 'clickaway') {
            return;
        }
        setShowSnack(false);
    }, []);
    var pause = useCallback(function () { return clearTimeout(timerID.current); }, []);
    var resume = useCallback(function () {
        initialDuration.current = RESUME_HIDE_DURATION;
        setAutoHideTimer(RESUME_HIDE_DURATION);
        timerID.current = +setInterval(function () { return setAutoHideTimer(function (previousAutoHideTimer) { return previousAutoHideTimer - 10; }); }, 10);
    }, []);
    var handleMouseEnter = useCallback(function () { return pause(); }, [pause]);
    var handleMouseLeave = useCallback(function () { return resume(); }, [resume]);
    useEffect(function () {
        if (snack) {
            setShowSnack(true);
        }
    }, [snack]);
    useEffect(function () {
        timerID.current = +setInterval(function () { return setAutoHideTimer(function (previousAutoHideTimer) { return previousAutoHideTimer - 10; }); }, 10);
    }, []);
    useEffect(function () {
        if (!autoHideTimer) {
            setShowSnack(false);
            clearTimeout(timerID.current);
        }
    }, [autoHideTimer]);
    return (_jsx(Snackbar, __assign({ open: showSnack, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, onClose: handleClose, className: styles.snackBar }, { children: _jsx(MuiAlert, __assign({ classes: { root: styles.alert }, severity: snack === null || snack === void 0 ? void 0 : snack.type, icon: _jsx("div", {}), action: _jsx("div", __assign({ className: styles.closeButton, onClick: handleClose }, { children: _jsx("div", __assign({ className: styles.closeIconWrapper }, { children: _jsx(CloseIcon, { fontSize: "inherit" }) })) })) }, { children: _jsx("div", __assign({ className: styles.alertInner }, { children: typeof (snack === null || snack === void 0 ? void 0 : snack.message) === 'string'
                    ? snack === null || snack === void 0 ? void 0 : snack.message
                    : JSON.stringify(snack === null || snack === void 0 ? void 0 : snack.message, null, 2) })) })) })));
};
export default memo(SnackBar);
//# sourceMappingURL=SnackBar.js.map